;(function (angular) {
  'use strict'

  angular
    .module('kilo.routes.order.list', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = [ '$stateProvider' ]

  function RouteConfigurator ($stateProvider) {
  /*  var listState = {
      name: 'order.list',
      url: '/list',
      resolve: {
        pagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('orderList')
        } ],
        linkedSearch: [ '$stateParams', function ($stateParams) {
          return $stateParams.linkedSearch
        } ],
        referers: ['UserManager', function (UserManager) {
          return UserManager.getReferers().then(function (data) {
            return data.data
          })
        }]
      },
      params: {
        linkedSearch: {}
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/order/list/templates/order-list.template.html',
          controller: 'OrderListController',
          controllerAs: 'list'
        },
        'toolbar@': {
          templateUrl: '/app/modules/order/list/templates/order-list-toolbar.template.html',
          controller: function () {},
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: 'Situations'
      }
    }
    $stateProvider
      .state(listState)*/
  }
})(window.angular)
